import React from "react";
import { DEV } from "./env";

export interface FeatureToggleInterface {
  toggles():object,
  updateToggle(name: string, vals: string[]): any,
  useToggle(name: string): (control: any, feature: any) => any
}
export const FeatureToggleContext = React.createContext({
  toggles:()=>{},
  updateToggle: (name, vals) => {},
  useToggle: (name) => (control: any, features: any):any => {}
});

export function featureToggleContextValue(state: any, setState: any, env: string = DEV): FeatureToggleInterface {
  var toggles = state;
  const updateTheStates = (name: string, vals: string[]) => {
    const lowerName = name.toLowerCase();
    const upperVals = vals.map((val) => val.toUpperCase());
    if (state[lowerName]) {
      toggles = {...toggles, [lowerName]:upperVals};
      setState({...state, [lowerName]:upperVals});
    }
  };
  return {
    toggles: () => toggles,
    updateToggle: updateTheStates,
    useToggle: (name: string) => {
      return (control: any, feature: any) => {
        var isControl = toggles[name]?.includes(env) ? false : true;
        return isControl ? control : feature;
      }
    }
  }
}
